// extracted by mini-css-extract-plugin
export default {"loaded_picture":"styles_loaded_picture__vCIDg","fallback_svg":"styles_fallback_svg__GjQjO"};